// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-role-dialog.common-dialog[data-v-672bcf99] .el-dialog{width:var(--common-dialog-width)}.add-role-dialog.common-dialog .el-form[data-v-672bcf99]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
